import cryptico from 'cryptico';
import {lstorage} from 'utils/lstorage.js';
import accounts from 'accounts/Accounts.js';
import {setPasswordModalCallback, setShowPasswordModal} from 'actions/index.js';
import {splitIntoBytes32} from './splitIntoBytes32.js';
import ethereum from 'decentralized/ethereum.js';

const BITS = 1024;

class PasswordManager {
    constructor(store) {
        this.store = store;
        this.masterKey = undefined;
        this.masterPublicKey = undefined;
        this.promptingPassword = false;
    }

    needsPassword() {
        return this.masterPublicKey === undefined;
    }

    set password(password) {
        if (password === undefined) {
            return;
        }
        this.masterKey = cryptico.generateRSAKey(password, BITS);
        this.masterPublicKey = cryptico.publicKeyString(this.masterKey);
        accounts.getAccount().then(
            userId => {
                if (!window.isNFT) {
                    lstorage.setItem("user_password." + userId, password);
                }
            });
    }

    async isCorrectPassword(password) {
        let publicKey = await ethereum.encryption.getPublicKey();
        if (publicKey === undefined) {
            return true;
        }
        let masterKey = cryptico.generateRSAKey(password, BITS);
        let masterPublicKey = cryptico.publicKeyString(masterKey);
        let ret = publicKey === masterPublicKey;
        return ret;
    }

    // syncs the public key to ethereum
    async syncPassword() {
        if (this.masterPublicKey === undefined) {
            this.password = await this.getPassword();
        }
        let publicKey = this.getPublicKeyAsBytes32();
        ethereum.encryption.newPublicKey(publicKey);
    }

    getPublicKeyAsBytes32(publicKey=this.masterPublicKey) {
        let masterPublicKey = ethereum.web3.utils.toHex(publicKey);
        return splitIntoBytes32(
            masterPublicKey);
    }

    sleep(x) {
        return new Promise((resolve, reject) => {
            resolve();
        }, x);
    }

    getPassword() {
        if (this.passwordPromise) {
            return this.passwordPromise;
        }

        this.passwordPromise = new Promise(async (resolve, reject) => {
            if (this.masterPublicKey !== undefined) {
                // no need to get password 
                resolve(undefined);
                return;
            }

            let userId = await accounts.getAccount();
            
            if (!window.isNFT && lstorage.getItem("user_password." + userId) !== null) {
                let password = lstorage.getItem("user_password." + userId);
                if (this.isCorrectPassword(password)) {
                    this.password = password;
                    resolve(password);
                    return;
                }
            }

            this.store.dispatch(setPasswordModalCallback((password) => {
                if (password === undefined) {
                    this.passwordPromise = undefined;
                    return;
                }
                this.password = password;
                // TODO: determine how unsecure this is
                resolve(password);
            }));
            this.store.dispatch(setShowPasswordModal(true));
        });
        return this.passwordPromise;
    }

    async getPublicKeyIfNeeded(publicKey) {
        if (publicKey === undefined) {
            if (this.masterPublicKey === undefined) {
                this.password = await this.getPassword();
            }
            publicKey = this.masterPublicKey;
        }

        return publicKey;
    }

    async getPrivateKeyIfNeeded(masterKey) {
        if (masterKey === undefined) {
            if (this.masterKey === undefined) {
                this.password = await this.getPassword();
            }
            masterKey = this.masterKey;
        }
        return masterKey;
    }
}

export default PasswordManager;
